import { Component, OnInit, ViewChild } from '@angular/core';
import { Incident } from '../models/incident';
import { IncidentService } from '../services/incident.service';
import { Router } from '@angular/router';
import { genericSortingAccessor } from '../shared.module';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-incidenten',
  templateUrl: './incidenten.component.html',
  styleUrls: ['./incidenten.component.scss']
})
export class IncidentenComponent implements OnInit {
  dataSource = new MatTableDataSource<Incident>();
  displayedColumns: string[] = [
    'incidentNummer',
    'brwStartDtg',
    'locatie',
    'plaatsnaam',
    'brwMeldingsclassificatie'
  ];
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  constructor(private router: Router, private incidentSvc: IncidentService) {}

  ngOnInit() {
    this.incidentSvc.load().subscribe((o) => {
      this.dataSource.data = o;
      this.dataSource.sort = this.sort;
      this.dataSource.sortingDataAccessor = genericSortingAccessor;
    });
  }
}
